import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Box, Button, Typography } from '@heycater/design-system';

import ImageCardSlider from 'static_pages/components/ImageCardSlider';

export default function ImageGalleryWithCaption({
  title,
  caption,
  images = [],
  ctaTitle,
  ctaLink,
}) {
  return (
    <Box maxWidth={1050} mx="auto">
      <Box textAlign="center" py={3} px={2}>
        <Typography variant="h3">{title}</Typography>
        <Typography varaint="body2">
          {documentToReactComponents(caption)}
        </Typography>
        <Box>
          <ImageCardSlider
            items={images.map(({ fields }, index) => {
              const { image, link, title } = fields;
              const backgroundImage = image?.fields?.file
                ? `https:${image.fields?.file?.url}?w=400`
                : '';

              return {
                key: index,
                href: link || '',
                cta: title,
                imageSrc: backgroundImage,
                pillText: '',
                ctaTextAlign: 'left',
              };
            })}
          />
        </Box>
        {ctaLink ? (
          <Box my={3}>
            <Button varaint="primary" href={ctaLink} target="_blank">
              {ctaTitle}
            </Button>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}
